// src/components/EditWorkEventModal.js

function EditWorkEventModal({
  isOpen,
  onClose,
  selectedWorkEvent,
  setSelectedWorkEvent,
  currentUser,
  auth,
  API_BASE_URL,
  employees,
  fetchAllEvents,
  setToast,
  handleSaveWorkEdit,
  setIsViewingWorkEventModalOpen,
}) {
  if (!isOpen || !selectedWorkEvent) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans">
        <h3 className="text-xl font-bold mb-4 text-orange-700">Edit Work Event</h3>

        <div className="space-y-3">
          <input
            type="text"
            placeholder="Event Description"
            value={selectedWorkEvent.description}
            onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, description: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />
          <input
            type="datetime-local"
            value={selectedWorkEvent.date_and_time}
            onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, date_and_time: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />

          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={selectedWorkEvent.primary_technician || ""}
            onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, primary_technician: e.target.value })}
          >
            <option value="" disabled>Primary Technician</option>
            {employees.slice().sort((a, b) => a.name.localeCompare(b.name)).map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>

          {/* Additional Technicians */}
          <p className="text-base text-black">Additional Technicians:</p>
          <p className="text-sm text-gray-500 mb-1">Hold Ctrl (Windows) or Cmd (Mac) to select multiple technicians</p>
          <select
            multiple
            className="border p-2 w-full mb-2 h-40"
            value={selectedWorkEvent.additional_technicians ? selectedWorkEvent.additional_technicians.split(",").map(t => t.trim()) : []}
            onChange={(e) => {
              const selected = Array.from(e.target.selectedOptions, opt => opt.value);
              setSelectedWorkEvent({ ...selectedWorkEvent, additional_technicians: selected.join(", ") });
            }}
          >
            {employees.slice().sort((a, b) => a.name.localeCompare(b.name)).map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>

          <input placeholder="Property" value={selectedWorkEvent.property} onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, property: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="Street Address" value={selectedWorkEvent.address_line} onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, address_line: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="City" value={selectedWorkEvent.city} onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, city: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="State" value={selectedWorkEvent.state} onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, state: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="Zipcode" value={selectedWorkEvent.zipcode} onChange={(e) => setSelectedWorkEvent({ ...selectedWorkEvent, zipcode: e.target.value })} className="w-full border px-3 py-2 rounded" />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
          <button
            onClick={async () => {
              const success = await handleSaveWorkEdit(selectedWorkEvent);

              if (success) {
                onClose();
                setIsViewingWorkEventModalOpen(false);
                setSelectedWorkEvent(null);
                fetchAllEvents();
              }
            }}
            className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditWorkEventModal;
